/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setCreateButton.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * ボタンを作成する
 */
const setCreateButton = () => {
    document.querySelectorAll('.post__container .button-wrapper').forEach((wrap) => {
        let i = document.createElement('i');
        i.className = 'arrow';

        let target = wrap.querySelector('a');
        if (!target) {
            target = document.createElement('span');
            target.innerHTML = wrap.innerText;
            wrap.innerHTML = '';
            wrap.appendChild(target);
        }

        target.className += ' button --normal';
        target.appendChild(i);
    });
}
export { setCreateButton }